<template>
  <div>
    <p>{{ this.$t("nopermision.callForHelp") }}</p>
  </div>
</template>

<script>
export default {
  name: "pageNoPermission",
}
</script>

<style></style>
